import React from 'react';
import { useConfirm } from '../hooks/useConfirm';
import { customStylesModal } from './ConfirmModal';
import { useTheme } from '../hooks/useTheme';
import Modal from 'react-modal';
import { useAuth } from '../hooks/useAuth';
import { LoginType } from '../models/LoginType';
import InputOtp from './InputOtp';
import { OtpReason } from '../repositories/AuthRepository';

interface OtpDialogProps {}

const OtpDialog: React.FC<OtpDialogProps> = () => {
    const { otpDialogIsOpen, otpDialogData, closeOtpDialog } = useConfirm();
    const {isMobile} = useTheme();
    const { updateCurrentPleb } = useAuth();

    return (
        <Modal
            isOpen={otpDialogIsOpen}
            onRequestClose={closeOtpDialog}
            style={customStylesModal('440px', isMobile ? true : false)}
        >
            <InputOtp 
                loginType={otpDialogData?.loginType ?? LoginType.EMAIL} 
                email={otpDialogData?.email ?? ''} 
                npub={otpDialogData?.npub ?? ''} 
                otpId={otpDialogData?.otpId ?? ''} 
                onVerify={async (credentials, pleb) => {
                    await updateCurrentPleb(pleb);
                    closeOtpDialog();
                }}
                otpReason={OtpReason.UPDATE}
            />
        </Modal>
    )
}

export default OtpDialog;